<template>
  <div class="seat-page">
    <div class="compere">
      <div
        class="seat-item"
        v-if="seatList && seatList[0] && seatList[0].userUuid"
        @click="handleClickSeat(0, seatList[0].userUuid)"
      >
        <div
          class="seat-avatar-box"
          :class="{ speaking: seatList[0].volume ? true : false }"
        >
          <img
            class="seat-avatar"
            :src="$util.setImageSize(seatList[0].avatarURL, 100, 100)"
            alt=""
          />
          <img
            class="seat-avatar-frame"
            :src="
              getAvatarFrame(seatList[0].userUuid) || seatList[0]['avatarFrame']
            "
            alt=""
            v-if="
              seatList[0]['avatarFrame'] || getAvatarFrame(seatList[0].userUuid)
            "
          />
        </div>
        <div class="seat-user-name">
          {{ seatList[0].nickname }}
        </div>
        <div class="charm-value" v-if="seatList[0].rankingScore != undefined">
          <img
            src="../images/icon-gift2.png"
            alt=""
            srcset=""
            class="icon-score"
          />
          {{ seatList[0].rankingScore }}
        </div>
      </div>
      <div
        class="seat-item"
        @click="handleClickSeat(0, seatList[0].userUuid)"
        v-else
      >
        <img
          class="seat-placeholder"
          src="../images/voice_room_seat_empty.webp"
          alt=""
        />
        <div class="seat-user-name">{{$t('components_voiceroom_component_seat_page_1903')}}</div>
      </div>
    </div>
    <div class="seat-list" v-if="seatList">
      <div
        v-for="(item, index) of seatList.slice(1)"
        :key="index"
        class="seat-item"
        @click="handleClickSeat(index + 1, item.userUuid)"
      >
        <template v-if="item.userUuid">
          <div
            class="seat-avatar-box"
            :class="{ speaking: item.volume ? true : false }"
          >
            <img class="seat-avatar" :src="item.avatarURL" alt="" />
            <img
              class="seat-avatar-frame"
              :src="item['avatarFrame'] || getAvatarFrame(item.userUuid)"
              alt=""
              v-if="item['avatarFrame'] || getAvatarFrame(item.userUuid)"
            />
          </div>
          <div class="seat-user-name">
            {{ item.nickname }}
          </div>
          <div class="charm-value" v-if="item.rankingScore != undefined">
            <img
              src="../images/icon-gift2.png"
              alt=""
              srcset=""
              class="icon-score"
            />
            {{ item.rankingScore }}
          </div>
        </template>
        <template v-if="!item.userUuid">
          <div class="seat-placeholder is-apply" v-if="isApplyMic">
            <div>{{$t('components_voiceroom_component_seat_page_1904')}}</div>
          </div>
          <img
            class="seat-placeholder"
            src="../images/voice_room_seat_empty.webp"
            alt=""
            v-else
          />
          <div class="seat-user-name">{{$t('components_photolist_index_1799')}}</div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import SeatProvider from '@/components/VoiceRoom/seatProvider';
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';

export default {
  name: 'SeatPage',
  props: {},
  data() {
    return {
      loading: null,
      seatList: null
    };
  },
  watch: {
    imSeatList: {
      handler(val) {
        this.seatList = val;
        this.seatList.forEach(async item => {
          if (item && item.userUuid) {
            const user = await VoiceRoomIM.getMemberProfile(item.userUuid);
            if (user) {
              item['avatarFrame'] = this.getAvatarFrame(item.userUuid);
            }
          }
        });
      },
      immediate: false
    }
  },
  computed: {
    // 麥位
    imSeatList() {
      return SeatProvider.list;
    },
    // 是否申請麥位
    isApplyMic() {
      return SeatProvider.isApplyMic;
    },
    // 是否房主
    isCreate() {
      return CurrentUserProvider.isCreate;
    },
    // 是否管理員
    isAdmin() {
      return CurrentUserProvider.isAdmin;
    },
    roomId() {
      return VoiceRoomProvider.roomInfo
        ? VoiceRoomProvider.roomInfo.roomUid
        : '';
    },
    currentUserInfo() {
      return CurrentUserProvider.userInfo;
    }
  },
  methods: {
    /**
     * @description: 點擊麥位
     * @param {*} seatIndex
     * @param {*} user
     * @return {*}
     */
    async handleClickSeat(seatIndex, userId) {
      console.log('handleClick');
      try {
        if (this.loading) {
          this.$message(i18n.t('components_voiceroom_component_seat_page_1905'));
          return;
        }
        if (userId) {
          this.$emit('click-seat', userId);
          this.loading = false;
          return;
        }
        this.loading = true;
        if (seatIndex === 0) {
          if (this.isCreate || this.isAdmin) {
            // const member = await VoiceRoomIM.getMemberProfile(
            //   this.currentUserInfo.uuid
            // );
            // console.log(member);
            // if (member) {
            //   await SeatProvider.hostTakeSeat(member);
            // }
            await SeatProvider.hostTakeSeat(this.currentUserInfo.uuid);
          } else {
            this.$message(i18n.t('components_voiceroom_component_seat_page_1906'));
          }
        } else if (SeatProvider.isOnSeat || this.isCreate || this.isAdmin) {
          await SeatProvider.changeSeat(this.roomId, seatIndex);
        } else {
          await SeatProvider.applyMic(seatIndex);
        }
        await new Promise(resolve => {
          setTimeout(() => {
            this.loading = false;
            resolve();
          }, 2000);
        });
      } catch (error) {
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomId, fun: 'seat-page-handleClickSeat' },
          error
        );
      }
    },
    getAvatarFrame(userId) {
      const res = VoiceRoomIM.getMemberPfpFrame(userId);
      return res ? res.url : '';
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes pulse {
  0% {
    width: 70px;
    height: 70px;
    opacity: 1;
  }
  100% {
    width: 90px;
    height: 90px;
    opacity: 0;
  }
}
.seat-page {
  padding: 0 18px;
  margin-top: 30px;
  .compere {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .seat-list {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .seat-item {
    display: inline-flex;
    flex-direction: column;
    width: 112px;
    margin-top: 12px;
    font-size: 14px;
    color: rgba(217, 200, 220, 0.8);
    // color: white;
    padding-top: 20px;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    position: relative;
    height: 156px;
    .seat-avatar-box {
      position: relative;
      width: 80px;
      height: 80px;
      &.speaking {
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 40px;
          height: 40px;
          // background-color: rgba(255, 255, 255, 0.2);
          background-color: inherit;
          border-radius: 50%;
          z-index: 1;
          animation: pulse 1s linear infinite;
          border: 10px solid white;
        }
      }
    }

    .seat-avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
    .seat-avatar-frame {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(1.43);
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
    .seat-user-name {
      padding-top: 12px;
      white-space: nowrap;
      @include ellipsis;
      text-align: center;
      width: 100%;
    }
    .seat-placeholder {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      font-size: 12px;
      justify-content: center;
      &.is-apply {
        background-color: #b0b2b3;
      }
    }
    .charm-value {
      font-size: 14px;
      padding: 2px 7px 2px 4px;
      border-radius: 12px;
      color: rgba(217, 200, 220, 0.8);
      background-color: rgba(0, 0, 0, 0.2);
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      margin-top: 8px;
      .icon-score {
        width: 18px;
        margin-right: 6px;
      }
    }
  }
}
</style>
